import React from 'react'
import { Layout as RaLayout, usePermissions } from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import AppBar from './AppBar'
import Menu from './Menu'
import Footer from './Footer'
import { useBrand } from '../hooks/useBrand'
import { USER_ROLES } from '../constants'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  content: {
    flex: 1,
    display: 'flex',
  },
}))

// Empty sidebar component for RAD_TECH users
const NoSidebar = () => null

const Layout = (props) => {
  const classes = useStyles()
  const brand = useBrand()
  const { permissions } = usePermissions()
  
  // RAD_TECH users get no sidebar - content takes full width
  const isRadTech = permissions === USER_ROLES.RAD_TECH

  return (
    <div className={classes.root}>
      <RaLayout
        {...props}
        appBar={AppBar}
        theme={brand.theme}
        menu={Menu}
        sidebar={isRadTech ? NoSidebar : undefined}
        className={classes.content}
      />
      <Footer />
    </div>
  )
}

export default Layout
